import React from 'react';
import * as consts from '../../../const';

class ReportsService {
  /**
   *@description returns the reports list.
   * If the sites length is bigger the 1 then the first item will represent the option to download the report for all sites
   *
   * @param sites
   * @param downloadCallbackFn
   * @param allSitesLengthCond (default = 1)
   * @returns {Array @type ReportItem}
   */
  static composeReports({ sites, downloadCallbackFn, permissions = [] }) {
    const sitesElems = [];
    // [permission] - Will us this to search for permission constants and store them in a common/global module
    const EXPORT_OPT_IN_OPT_OUT_REPORT_ALL = 'EXPORT_OPT_IN_OPT_OUT_REPORT_ALL';
    let el,
      ALL_SITES_LENGTH_CONDITON = 1;

    if (sites.length > ALL_SITES_LENGTH_CONDITON && permissions.includes(EXPORT_OPT_IN_OPT_OUT_REPORT_ALL)) {
      el = { label: consts.RAPORTS_ALL_SITES, value: '*' };
      sitesElems.push(el);
    }

    for (let o of sites) {
      el = { label: o.org.name, value: o.org };
      sitesElems.push(el);
    }

    return sitesElems;
  }
}

export default ReportsService;
